export function isDarkTheme(): boolean {
  return document.body.classList.contains('login-dark-theme');
}

export function ideaIconPath(): string {
  return isDarkTheme() ? 'assets/images/ui/idea_dark.svg' : 'assets/images/ui/idea.svg';
}

export function loaderGifPath(): string {
  return isDarkTheme() ? 'assets/images/manager-loader-dark.gif' : 'assets/images/loader-grey.gif';
}
